export class CommentaryDatabase {
  private static data = {
    en: {
      MAINTAINING_FIRST_PLACE: [
        "is dominating the track, holding strong in first place",
        "is showing no signs of slowing down",
        "is keeping the competition at bay",
        "is pacing this very well",
        "is looking unbeatable at the moment",
        "is showing no signs of falling off the pace",
        "is setting the pace for the others",
        "is running a very smart race",
        "is leading the pack, showing incredible skill and determination",
        "is making it look easy out there",
        "is looking unbeatable at the moment",
        "is putting on a masterclass in racing",
        "is making it look easy out there",
        "is holding strong in first place",
        "is cruising towards victory",
        "remains unchallenged at the front",
        "continues to lead with authority",
        "is steadfastly guarding the lead",
        "holds the top spot with confidence",
        "is unwavering in the lead position",
        "maintains a commanding presence upfront",
        "is the undisputed leader of the pack",
        "keeps setting a blistering pace for the race",
        "is relentless in holding the lead",
        "stays ahead, unmatched and focused",
        "is the master of the track today",
        "holds onto the lead with ironclad determination",
        "is a beacon of excellence at the front",
        "is dictating the race's tempo effortlessly",
        "is steering clear of any challenge for the lead",
      ],
      NEW_RACE_LEADER: [
        "has moved into first place",
        "has taken the lead",
        "has surged to the front",
        "is now leading the pack",
        "has taken control of the race",
        "has catapulted to the top spot",
        "is setting the pace for the race",
        "has outpaced the competition to lead",
        "is at the forefront of the pack",
        "has clinched the pole position",
        "is dominating the track with the lead",
        "has ascended to the lead",
        "is the new frontrunner",
        "has overtaken rivals to lead",
        "is leading the charge",
        "has emerged as the race leader",
        "is now at the head of the field",
        "has secured the top position",
        "is pacing ahead of the competition",
        "has established a lead over the pack",
      ],
      RACER_IN_LAST_POSITION_OPTIONS: [
        "is currently in last place",
        "is at the back of the pack",
        "is struggling at the back",
        "is at the back of the field",
        "is currently in last place",
        "is at the back of the pack",
        "is bringing up the rear",
        "is trailing behind",
        "is fighting to catch up",
        "has yet to make a move from the end",
        "is looking for an opening from the last position",
        "is in the final position, but not out of the race",
        "is biding their time at the back",
        "is facing challenges at the rear",
        "is at the tail end of the race",
        "is lagging but looking for a comeback",
      ],
      SINGLE_RACER_POSITION_CHANGE_OPTIONS: [
        "has moved up a place",
        "is gaining ground",
        "is steadily moving up the field",
        "has made a move up the field",
        "is making progress",
        "has gained a position",
        "has edged forward to take another spot",
        "has inched up the rankings",
        "is climbing one step at a time",
        "has subtly advanced a position",
        "is incrementally making their way forward",
        "has nudged ahead of a competitor",
        "is methodically picking off positions",
        "has tactically moved up",
        "is one step closer to the front",
        "has secured a higher spot",
        "is progressively moving up",
        "has smartly gained a spot",
        "is carefully advancing",
        "has improved their standing",
        "is slowly but surely moving up",
      ],
      MULTIPLE_RACER_POSITION_CHANGE_OPTIONS: [
        "has made a remarkable climb",
        "is charging through the pack",
        "is making a stunning recovery",
        "is on a charge",
        "has gained significant ground",
        "has come out of nowhere",
        "is making a charge through the field",
        "has rapidly gained places",
        "has moved up multiple places",
        "has surged forward with incredible pace",
        "is slicing through the competition",
        "is climbing the ranks at a breathtaking speed",
        "has executed a series of masterful overtakes",
        "is rewriting the script of this race",
        "has left competitors in their wake",
        "is on a meteoric rise through the field",
        "is tearing up the track, moving up swiftly",
        "has catapulted up the leaderboard",
        "is advancing aggressively, leaving many behind",
        "has turned the tables with their rapid ascent",
        "is showcasing a remarkable turn of speed",
        "has shifted gears and is moving up fast",
        "is on a relentless pursuit up the order",
        "has blazed past rivals with ease",
        "is defying expectations with every lap",
        "is making waves and climbing rapidly",
        "has embarked on an astonishing rally",
        "is navigating the field with precision and speed",
        "has unleashed a spectacular performance to move up",
        "is soaring past competitors with ease",
        "has executed a masterful advance",
        "is navigating through the field like a pro",
        "has turned the race around with their skill",
        "is cutting through the competition with precision",
        "has left rivals in the dust with a swift ascent",
        "is ascending through the ranks impressively",
        "has catapulted forward with remarkable pace",
        "is on a meteoric rise through the field",
        "has blazed a trail up the leaderboard",
      ],
      FALLEN_OUT_OF_TOP_THREE_OPTIONS: [
        "has dropped out of the top three",
        "has slipped down the order",
        "has fallen out of the top three",
        "is losing ground rapidly",
        "is falling down the field",
        "is running out of steam",
        "has lost momentum",
        "is going the wrong way",
        "is losing momentum",
        "is slipping further away from the top spots",
        "finds themselves losing grip on the lead",
        "is watching the top three pull away",
        "has been edged out of the premier positions",
        "is facing a tough battle to reclaim their spot",
        "has taken a dive down the rankings",
        "is struggling to keep up with the pace",
        "is starting to fall out of contention",
      ],
      MULTI_RACER_COMMENTARY_OPTIONS: [
        "It's a nail-biter between {racer1}, {racer2}, and {racer3} with mere seconds separating them!",
        "{racer1}, {racer2}, and {racer3} are locked in a fierce battle for the lead!",
        "The tension is palpable as {racer1} tries to fend off {racer2} and {racer3}!",
        "{racer1} is leading, but {racer2} and {racer3} are hot on their heels!",
        "A thrilling contest between {racer1}, {racer2}, and {racer3} is unfolding!",
        "Can {racer1} maintain the lead with {racer2} and {racer3} challenging?",
        "{racer1} and {racer2} are closely leading the race, with {racer3} right behind them",
        "{racer1} and {racer2} maintain their top positions, with {racer3} keeping the pressure on",
        "In the lead, {racer1} and {racer2} are setting a fast pace, closely followed by {racer3}",
        "The top three, led by {racer1}, are holding steady, with {racer2} and {racer3} in contention",
        "{racer1} and {racer2} continue to lead, with {racer3} not far behind, keeping the race competitive",
        "As the race progresses, {racer1}, {racer2}, and {racer3} are consistently in the top spots",
        "The leading trio of {racer1}, {racer2}, and {racer3} are maintaining their positions at the front",
        "{racer1} and {racer2} are in a close race for the lead, with {racer3} poised to challenge them",
        "Holding their ground, {racer1}, {racer2}, and {racer3} remain the top contenders in this race",
        "{racer2} and {racer3}, in a concerted effort, are closing the gap on {racer1}",
        "Challenging the lead, {racer2} and {racer3} are setting their sights on overtaking {racer1}",
        "{racer2} and {racer3} are inching closer, putting pressure on {racer1} to maintain the pace",
        "{racer2} and {racer3} are inching closer to {racer1} with every turn",
        "The gap narrows as {racer2} and {racer3} push to overtake {racer1}",
        "{racer2} and {racer3} maintain their chase, keeping {racer1} within reach",
      ],
      RACE_FINISHED_OPTIONS: [
        "has won!",
        "has clinched victory",
        "has crossed the finish line first",
        "has taken the chequered flag",
        "has emerged victorious",
        "has triumphed",
        "has secured the win",
        "has claimed the top spot",
        "has finished first",
        "has come out on top",
        "has taken the win",
        "has held on for the victory",
        "has held off the competition for the win",
        "has rallied to victory",
      ],
    },
    fr: {
      MAINTAINING_FIRST_PLACE: [
        "domine la piste, tenant fermement la première place",
        "ne montre aucun signe de ralentissement",
        "garde la concurrence à distance",
        "se débrouille très bien",
        "semble imbattable pour le moment",
        "ne montre aucun signe de faiblesse",
        "fixe le rythme pour les autres",
        "court une course très intelligente",
        "mène le peloton, montrant une compétence et une détermination incroyables",
        "rend les choses faciles là-bas",
        "semble imbattable pour le moment",
        "donne une leçon de course",
        "rend les choses faciles là-bas",
        "tient fermement en première place",
        "se dirige vers la victoire",
        "reste incontesté en tête",
        "continue de mener avec autorité",
        "garde la tête avec confiance",
        "est inébranlable en position de tête",
        "maintient une présence dominante en tête",
        "est le leader incontesté du peloton",
        "continue de fixer un rythme effréné pour la course",
        "est implacable en tenant la tête",
        "reste en tête, sans égal et concentré",
        "est le maître de la piste aujourd'hui",
        "garde la tête avec une détermination inébranlable",
        "est une référence d'excellence en tête",
        "dicte le tempo de la course sans effort",
        "reste à l'écart de tout défi pour la tête",
      ],
      NEW_RACE_LEADER: [
        "est passé en première place",
        "a pris la tête",
        "a surgi en tête",
        "mène maintenant le peloton",
        "a pris le contrôle de la course",
        "a catapulté au sommet",
        "fixe le rythme pour la course",
        "a surpassé la concurrence pour mener",
        "est à l'avant du peloton",
        "a décroché la pole position",
        "domine la piste en tête",
        "est monté à la tête",
        "est le nouveau leader",
        "a dépassé ses rivaux pour mener",
        "mène la charge",
        "émerge comme le leader de la course",
        "est maintenant en tête du peloton",
        "a sécurisé la première position",
        "fixe le rythme devant la concurrence",
        "a établi une avance sur le peloton",
      ],
      RACER_IN_LAST_POSITION_OPTIONS: [
        "est actuellement en dernière place",
        "est à l'arrière du peloton",
        "lutte à l'arrière",
        "est à l'arrière du peloton",
        "est actuellement en dernière place",
        "est à l'arrière du peloton",
        "ferme la marche",
        "traîne derrière",
        "lutte pour rattraper",
        "n'a pas encore bougé de la dernière position",
        "cherche une ouverture depuis la dernière position",
        "est en dernière position, mais pas hors course",
        "prend son temps à l'arrière",
        "fait face à des défis à l'arrière",
        "est à la fin du peloton",
        "est en retard mais cherche un retour",
      ],
      SINGLE_RACER_POSITION_CHANGE_OPTIONS: [
        "a gagné une place",
        "gagne du terrain",
        "monte régulièrement dans le peloton",
        "a avancé d'une place",
        "fait des progrès",
        "a gagné une position",
        "a pris une autre place",
        "a grimpé dans le classement",
        "monte pas à pas",
        "a avancé subtilement d'une place",
        "progresse progressivement",
        "a avancé d'une position",
        "progresse méthodiquement",
        "a avancé tactiquement",
        "est un pas plus près de l'avant",
        "a sécurisé une place plus haute",
        "monte progressivement",
        "a intelligemment gagné une place",
        "avance prudemment",
        "a amélioré sa position",
        "monte lentement mais sûrement",
      ],
      MULTIPLE_RACER_POSITION_CHANGE_OPTIONS: [
        "a fait une remontée remarquable",
        "charge à travers le peloton",
        "fait une récupération spectaculaire",
        "est en pleine charge",
        "a gagné du terrain de manière significative",
        "vient de nulle part",
        "charge à travers le peloton",
        "a rapidement gagné des places",
        "a avancé de plusieurs places",
        "a avancé avec une incroyable rapidité",
        "tranche à travers la compétition",
        "grimpe les échelons à une vitesse époustouflante",
        "a exécuté une série de dépassements magistraux",
        "réécrit le script de cette course",
        "a laissé les concurrents dans son sillage",
        "est en pleine montée fulgurante",
        "déchire la piste, avançant rapidement",
        "a catapulté dans le classement",
        "avance agressivement, laissant beaucoup derrière",
        "a renversé la course avec son ascension rapide",
        "montre une vitesse remarquable",
        "a changé de vitesse et monte rapidement",
        "poursuit implacablement l'ordre de course",
        "a dépassé les rivaux avec facilité",
        "défie les attentes à chaque tour",
        "fait des vagues et grimpe rapidement",
        "a entamé une remontée spectaculaire",
        "navigue dans le peloton avec précision et vitesse",
        "a réalisé une performance spectaculaire pour avancer",
        "dépasse facilement les concurrents",
        "a exécuté une avance magistrale",
        "navigue dans le peloton comme un pro",
        "a renversé la course avec son habileté",
        "tranche à travers la compétition avec précision",
        "a laissé les rivaux dans la poussière avec une montée rapide",
        "grimpe dans les rangs de manière impressionnante",
        "a avancé avec une rapidité remarquable",
        "est en pleine montée fulgurante",
        "a tracé un chemin dans le classement",
      ],
      FALLEN_OUT_OF_TOP_THREE_OPTIONS: [
        "est tombé hors des trois premiers",
        "a glissé dans le classement",
        "est tombé hors des trois premiers",
        "perd du terrain rapidement",
        "descend dans le peloton",
        "manque de souffle",
        "a perdu de la vitesse",
        "va dans la mauvaise direction",
        "perd de la vitesse",
        "glisse encore plus loin des premières places",
        "perd de l'adhérence sur la tête",
        "regarde les trois premiers s'éloigner",
        "a été évincé des positions de tête",
        "fait face à une bataille difficile pour retrouver sa place",
        "a plongé dans le classement",
        "lutte pour suivre le rythme",
        "commence à perdre la compétition",
      ],
      MULTI_RACER_COMMENTARY_OPTIONS: [
        "C'est une lutte acharnée entre {racer1}, {racer2}, et {racer3} avec quelques secondes de différence!",
        "{racer1}, {racer2}, et {racer3} sont engagés dans une bataille féroce pour la tête!",
        "La tension est palpable alors que {racer1} tente de repousser {racer2} et {racer3}!",
        "{racer1} mène, mais {racer2} et {racer3} sont sur ses talons!",
        "Un concours palpitant entre {racer1}, {racer2}, et {racer3} se déroule!",
        "{racer1} peut-il maintenir la tête avec {racer2} et {racer3} en embuscade?",
        "{racer1} et {racer2} mènent la course de près, avec {racer3} juste derrière eux",
        "{racer1} et {racer2} gardent leurs positions de tête, avec {racer3} qui met la pression",
        "En tête, {racer1} et {racer2} fixent un rythme rapide, suivis de près par {racer3}",
        "Les trois premiers, menés par {racer1}, restent constants, avec {racer2} et {racer3} en lice",
        "{racer1} et {racer2} continuent de mener, avec {racer3} pas loin derrière, gardant la course compétitive",
        "Au fur et à mesure que la course progresse, {racer1}, {racer2}, et {racer3} maintiennent leurs positions en tête",
        "Le trio de tête composé de {racer1}, {racer2}, et {racer3} maintient leurs positions en tête",
        "{racer1} et {racer2} sont dans une course serrée pour la tête, avec {racer3} prêt à les défier",
        "En tenant bon, {racer1}, {racer2}, et {racer3} restent les principaux prétendants dans cette course",
        "{racer2} et {racer3}, en un effort concerté, réduisent l'écart avec {racer1}",
        "En défiant la tête, {racer2} et {racer3} visent à dépasser {racer1}",
        "{racer2} et {racer3} se rapprochent, mettant la pression sur {racer1} pour maintenir le rythme",
        "{racer2} et {racer3} se rapprochent de {racer1} à chaque virage",
        "L'écart se réduit alors que {racer2} et {racer3} poussent pour dépasser {racer1}",
        "{racer2} et {racer3} poursuivent leur chasse, gardant {racer1} à portée de main",
      ],
      RACE_FINISHED_OPTIONS: [
        "a gagné!",
        "a décroché la victoire",
        "a franchi la ligne d'arrivée en premier",
        "a pris le drapeau à damier",
        "a émergé victorieux",
        "a triomphé",
        "a remporté la victoire",
        "a pris la première place",
        "a fini premier",
        "est sorti vainqueur",
        "a remporté la course",
        "a tenu bon pour la victoire",
        "a repoussé la concurrence pour la victoire",
        "a rallié pour la victoire",
      ],
    },
    // Add more languages here
  };

  public static getOptions(language: string, category: string): string[] {
    // Check if the language is valid JSON
    let parsed;
    try {
      parsed = JSON.parse(language);
    } catch (error) {
      parsed = "en"; // Default to English
    }

    const result = this.data[parsed]?.[category] || this.data["en"][category];
    return result;
  }
}
